var render = function render(){var _vm=this,_c=_vm._self._c;return _c('spinner',{attrs:{"status":_vm.status,"depth":_vm.depth,"size":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }